// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
promise.polyfill()
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import ElementUI from 'element-ui'
import JsonExcel from 'vue-json-excel'
import 'element-ui/lib/theme-chalk/index.css'
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.axios = axios;
axios.defaults.withCredentials = true
Vue.component('downloadExcel', JsonExcel)

// http response 拦截器
axios.interceptors.response.use(
  response => {
      //console.log(response)
      if (response.data.code === 301) {
      router.replace('/login');
      }
      return response;
  },
  error => {
      return Promise.reject(error);
  }
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js